import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { ListDTO } from 'src/registry/types/queries';
import { formatResourcePath } from 'src/utils/regex';
import { ListResponseAPI } from 'src/lib/queries';
import { BankAccount } from 'src/features/billingEntityBankAccounts/utils/types';

const RESOURCE = '/customers/billing-entity-bank-account/';

type QueryFnType = typeof queryFn;

interface DTO extends ListDTO {
    billing_entity?: string;
    is_active?: boolean;
}

const queryFn = ({ ...params }: DTO): Promise<ListResponseAPI<BankAccount>> => {
    return axios.get(formatResourcePath(RESOURCE), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { RESOURCE as LIST_BILLING_ENTITY_BANK_ACCOUNTS_RESOURCE, useQueryHook as useListBillingEntityBankAccounts };
